"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgGantt = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M2 3a1 1 0 012 0v17h17a1 1 0 010 2H3a1 1 0 01-1-1V3z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.75 7.5a1 1 0 011-1h8a1 1 0 010 2h-8a1 1 0 01-1-1zM10 16.5a1 1 0 011-1h6a1 1 0 010 2h-6a1 1 0 01-1-1zM8 12a1 1 0 011-1h10a1 1 0 010 2H9a1 1 0 01-1-1z' }))); };
exports.default = SvgGantt;
//# sourceMappingURL=Gantt.js.map